import { memo } from 'react';

import { CopyText, Flex, Label, Link, Text } from '@/components/core';
import { toAppClientId, useGetAppClient, useListAppClients } from '@/hooks/api';

export type TriggerAPIConfigurationProps = object;

// eslint-disable-next-line no-empty-pattern
const ITriggerAPIConfiguration = ({}: TriggerAPIConfigurationProps = {}) => {
  const { data: appClients } = useListAppClients();
  const appClientWithSecret = appClients?.data?.find((appClient) => appClient.hasSecret);

  const { data: appClient } = useGetAppClient(toAppClientId(appClientWithSecret?.appClientId), {
    refetchInterval: (query) => (!query.state.data?.clientSecret ? 2000 : undefined),
  });

  return (
    <Flex col className="gap-md p-md grow">
      <Label>API Credentials</Label>

      <Flex variant="plain" col className="p-md gap-4 rounded-lg border-1 border-gray-100 bg-white shadow-xs">
        <Flex col className="gap-xs">
          <Label>Client ID</Label>
          <CopyText value={appClient?.clientId} />
        </Flex>

        <Flex col className="gap-xs">
          <Label>Client Secret</Label>
          <CopyText isSensitive value={appClient?.clientSecret} />
        </Flex>
      </Flex>

      <Text>
        Read API documentation<span> </span>
        <Link href="https://docs.cradl.ai/api-reference/introduction" className="font-regular text-sm">
          here.
        </Link>
      </Text>
    </Flex>
  );
};

export const TriggerAPIConfiguration = memo(ITriggerAPIConfiguration) as typeof ITriggerAPIConfiguration;
